module.exports = __webpack_public_path__ + "static/media/excel.ec3aeae1.svg";